import { useMemo } from "react";
import PropTypes from "prop-types";
import CssBaseline from "@mui/material/CssBaseline";
import {
  createTheme,
  ThemeProvider as MUIThemeProvider,
} from "@mui/material/styles";
import { typography } from "./typography";
import { overrides } from "./overrides";

const pink = "#1D5AB9";
const lightblue = "#ADD8E6";
const purple = "#800080";
const black = "#000000";

export default function ThemeProvider({ children }) {
  const memoizedValue = useMemo(
    () => ({
      palette: {
        common: {
          pink: pink,
          lightblack: "#404040",
          lightblue: lightblue,
          purple: purple,
          black: black,
          inputCustomLable: "#444444",
          buttonText: "#FFFFFF",
          versionText: "#605E5C",
          fontFamily: "Segoe UI",
        },
        primary: {
          main: "#1D5AB9",
        },
        secondary: {
          main: lightblue,
        },
      },
      typography,
      shape: { borderRadius: 8 },
    }),
    [],
  );

  const theme = createTheme(memoizedValue);

  theme.components = overrides(theme);

  return (
    <MUIThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  );
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
};
